module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "section-card review-health-card"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
    }
  })])]), _vm._v("\n      Review Health\n    ")])]), _vm._v(" "), (_vm.waiting) ? _c('div', {
    staticClass: "review-health-waiting"
  }, [_vm._v("\n    Waiting for Amazon's first review data\n  ")]) : [_c('div', {
    staticClass: "health-metrics review-health-metrics"
  }, [_c('div', {
    staticClass: "health-metric"
  }, [_c('span', {
    staticClass: "health-metric-name"
  }, [_vm._v("Star rating")]), _vm._v(" "), _c('span', {
    staticClass: "health-metric-value",
    class: {
      critical: _vm.flagged('rating_drop')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ratingText) + "\n          "), (_vm.previousRatingText) ? _c('span', {
    staticClass: "threshold"
  }, [_vm._v(_vm._s(_vm.previousRatingText))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "health-metric"
  }, [_c('span', {
    staticClass: "health-metric-name"
  }, [_vm._v("Rating count")]), _vm._v(" "), _c('span', {
    staticClass: "health-metric-value",
    class: {
      critical: _vm.flagged('rating_count_drop')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.countText) + "\n          "), (_vm.countDeltaText) ? _c('span', {
    staticClass: "threshold"
  }, [_vm._v(_vm._s(_vm.countDeltaText))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "health-metric"
  }, [_c('span', {
    staticClass: "health-metric-name"
  }, [_vm._v("Critical reviews, last 30 days")]), _vm._v(" "), _c('span', {
    staticClass: "health-metric-value",
    class: {
      critical: _vm.flagged('new_critical_reviews')
    }
  }, [_vm._v(_vm._s(_vm.critical30dText))])]), _vm._v(" "), (_vm.sparkline) ? _c('div', {
    staticClass: "review-health-trend"
  }, [_c('div', {
    staticClass: "review-health-trend-label"
  }, [_c('span', [_vm._v("Rating count, last " + _vm._s(_vm.sparkline.days) + " days")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sparkline.firstText) + " → " + _vm._s(_vm.sparkline.lastText))])]), _vm._v(" "), _c('svg', {
    staticClass: "review-health-sparkline",
    attrs: {
      "viewBox": "0 0 200 40",
      "preserveAspectRatio": "none",
      "role": "img",
      "aria-label": 'Rating count trend: ' + _vm.sparkline.firstText + ' to ' + _vm.sparkline.lastText
    }
  }, [_c('polyline', {
    attrs: {
      "points": _vm.sparkline.points,
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round",
      "stroke-linecap": "round"
    }
  })])]) : _vm._e()])], _vm._v(" "), _c('div', {
    staticClass: "review-health-footer"
  }, [(_vm.asOfText) ? _c('span', {
    staticClass: "review-health-asof"
  }, [_vm._v("Amazon data as of " + _vm._s(_vm.asOfText))]) : _vm._e(), _vm._v(" "), (_vm.reviewsUrl) ? _c('a', {
    staticClass: "review-health-link",
    attrs: {
      "href": _vm.reviewsUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Read reviews on Amazon")]) : _vm._e()])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f46a47a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-details/ReviewHealth.vue
// module id = 820
// module chunks = 2